// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"592":"1a65cc9e","6082":"b86078b3","7594":"e96dfb41"}[chunkId] + ".chunk.css";
};